export enum DriverTrackingStatus {
  ALL = 'All',
  AVAILABLE = 'Available',
  UNAVAILABLE = 'UnAvailable'
}
